import { useState, useEffect } from "react";
import { CircularProgress, Box } from "@mui/material";

import { useNavigate, useParams } from "react-router-dom";
import { CustomGrid } from "../../../components/tableComponent";
import LeaguesStatus from "../../my_leagues/leagueByID/leaguesStatus";
import moment from "moment";

const JoinedLeagueTable = ({ data }) => {
  const navigate = useNavigate();
  // State management
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sortModel, setSortModel] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const { id: league_id } = useParams();
  console.log("joined league table length == ", data?.length);
  // Column definitions
  const columns = [
    {
      field: "start_date",
      headerName: "Start Date",
      minWidth: 120,
      sortable: true,
      flex: 1,
      renderCell: (params) => {
        return moment(params.row.start_date).format("MM/DD/YYYY")
      }
    },
    {
      field: "end_date",
      headerName: "End Date",
      minWidth: 120,
      sortable: true,
      flex: 1,
      renderCell: (params) => {
        return moment(params.row.end_date).format("MM/DD/YYYY")
      }
    },
    {
      field: "season_name",
      headerName: "Name",
      minWidth: 200,
      sortable: true,
      flex: 2,
    },
    {
      field: "weeks_for_season_games",
      headerName: "# of Weeks",
      minWidth: 110,
      sortable: true,
      flex: 1.5,
    },
    {
      field: "starting_theme",
      headerName: "Theme",
      minWidth: 150,
      sortable: true,
      flex: 1.5,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 120,
      sortable: true,
      flex: 1.5,
      renderCell: (params) => <LeaguesStatus data={params.row} />,
    },
  ];

  // Event handlers
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0); // Reset to first page when changing page size
  };

  const handleSortChange = (newSortModel) => {
    setSortModel(newSortModel);
  };

  const handleRowSelectionChange = (newSelection) => {
    setSelectedRows(newSelection);
  };

  const handleRowClick = (params) => {
    console.log("Row clicked:", params.row);
    navigate(`/joined_leagues/${league_id}/season/${params.row.season_id}`);
  };

  // Loading state
  if (loading && !data.length) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      <CustomGrid
        columns={columns}
        data={data}
        loading={loading}
        perPageCount={pageSize}
        currentPage={page}
        totalPages={totalRecords}
        isServerPagination={false}
        // isServerSorting={true}
        onChangeRecords={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        onSortModelChange={handleSortChange}
        onRowClick={handleRowClick}
        // checkboxSelection={true}
        onRowSelectionModelChange={handleRowSelectionChange}
        rowHeight={56}
        selectedCount={selectedRows.length}
        selectionModel={selectedRows}
        searchBar={null}
        disableSorting={true}
      />
    </Box>
  );
};

export default JoinedLeagueTable;
